module.exports = __webpack_public_path__ + "static/media/b2.39cac3a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenlong/b2.mp3
// module id = UqO8
// module chunks = 0